<template>
  <div class="form-group">
    <div class="actions">
      <div class="action-item">
        <button class="btn btn-default" type="button"
                @click="addResponse"><i class="fa fa-plus"></i> Add Scoring Option
        </button>
      </div>
      <div class="action-item time-limit">
        <input id="multiselect" v-model="content.question.multiselect" class="mr-1" type="checkbox">
        <label class="control-label" for="multiselect">Multiple Select (with Submit)</label>
      </div>
      <div class="action-item">
        <input id="randomize" v-model="content.question.randomize" class="mr-1" type="checkbox">
        <label class="control-label" for="randomize">Randomize Responses</label>
      </div>
      <div class="action-item">
        <input id="show-0-val-outcomes" v-model="content.showOutcomeOfZero" class="mr-1" type="checkbox">
        <label class="control-label" for="show-0-val-outcomes">Show outcomes with value of 0</label>
      </div>
    </div>
    <div class="content-list">
      <div v-for="(response, index) in content.question.responses" v-cloak :key="index"
           class="card content-list-item">
        <div class="card-header text-center font-weight-bold">{{ alphabet[index] }}</div>
        <div class="card-body">
          <div class="form-group row">
            <div class="col">
              <label class="control-label" for="label">Choice Text</label>
              <QuillEditor v-model:content="response.label" :contentType="'html'" :options="editorOptsLite"
                           theme="snow"/>
            </div>
            <div v-if="feedbackInput" class="col-sm-6">
              <label class="control-label" for="label">Feedback</label>
              <QuillEditor v-model:content="response.feedback" :contentType="'html'" :options="editorOptsLite"
                           theme="snow"/>
            </div>
          </div>
          <div class="form-group row">
            <div v-if="feedbackImage" class="col-sm-6">Feedback Image</div>
            <div v-if="flowHook" class="col-sm-3">
              <label class="control-label" for="flow">Flow Hook</label>
              <input v-model="response.flow" :placeholder="'choice-' + (index + 1)" class="form-control"
                     type="text">
            </div>
            <div v-if="outcomeTrigger" class="col-sm-3">
              <label class="control-label" for="flow">Outcome Trigger</label>
              <input v-model="response.trigger" :placeholder="'event-' + (index + 1)" class="form-control"
                     type="text">
            </div>
          </div>
          <div class="form-group card-metrics">
            <label class="control-label" for="metrics">Meter Effects</label>
            <div class="row">
              <div v-for="meter in response.meters" :key="meter.id" class="col-sm">
                <span :class="['badge', 'badge-primary', meter.id]">{{ meter.id }}</span>
                <input :id="meter.id" v-model="meter.value" class="form-control" type="number">
              </div>
              <div class="col-sm offset-sm-3">
                <label class="control-label">&nbsp;</label>
                <button class="btn btn-danger btn-block" type="button"
                        @click="remove(response, index)">Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="content.question.responses.length > 0">
      <div class="action-item">
        <button class="btn btn-default" type="button"
                @click="addResponse"><i class="fa fa-plus"></i> Add Scoring Option
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {EDITOR_CONFIG_LITE} from '../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {
    QuillEditor
  },
  props: ['content', 'opts'],
  data() {
    return {
      editorOptsLite: EDITOR_CONFIG_LITE,
      alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    }
  },
  computed: {
    outcomeTrigger: function () {
      if (!_.isUndefined(this.opts.outcomeTrigger)) {
        return this.opts.outcomeTrigger
      }
      return false
    },
    flowHook: function () {
      if (!_.isUndefined(this.opts.flowHook)) {
        return this.opts.flowHook
      }
      return false
    },
    feedbackInput: function () {
      if (!_.isUndefined(this.opts.feedbackInput)) {
        return this.opts.feedbackInput
      }
      return false
    },
    feedbackImage: function () {
      if (!_.isUndefined(this.opts.feedbackImage)) {
        return this.opts.feedbackImage
      }
      return false
    }
  },
  methods: {
    remove(item, index) {
      this.content.question.responses.splice(index, 1)
    },
    addResponse() {
      this.content.question.responses.push({
        meters: defaultMeters()
      })

      this.$nextTick(() => {
        $(this.$el).find('[data-lfm]').filemanager('image', {prefix: '/filemanager'})
      })
    }
  },
  mounted() {
  }
}
</script>
